
<div class="landlord_tabs">
  <div class="top">
    <div class="detail">
      <!-- <div class="picture"></div> -->
      <div class="the_details">
        <h2 class="name" style="color: black;">{{ selectedLessor?.LandOwnershipTypeName }}</h2>
        <p class="other_detail">
          <span class="icon">Phone No: {{ selectedLessor?.addressBook.PhoneNo }}</span>
          <span class="icon">Assigned Area:
            <ng-container *ngIf="assignedArea">{{assignedArea}}</ng-container>
            <ng-container *ngIf="!assignedArea">0</ng-container>
          </span>
          <span class="icon"> Account No: {{ selectedLessor?.addressBook.AccountNo }}</span>
          <span>Ownership Type: {{getOwnershipTypeName(selectedLessorInfo?.LandOwnershipTypeId )}}</span>
        </p>
      </div>
    </div>

    <div class="top_right">
      <button class="back" (click)="onBack()"><i class="ti-arrow-left" style="color:orange;"></i> Back to list</button>
      <button class="tab_button default_secondary-btn" (click)="onSurvey()">Survey Area (Marker)</button>
      <button class="tab_button default_secondary-btn" (click)="onLessorAcreage()">Acreages Description</button>
      <button class="tab_button default_secondary-btn" (click)="onLessorRep()">Representatives</button>
      <button class="tab_button default_secondary-btn" (click)="onLessorStakeholder()">Stakeholder</button>
    </div>
  </div>
  <div class="tab_contents" [ngSwitch]="tab">
    <ng-template  ngSwitchCase="surveyArea">
      <cradua-survey-area
      [selectedLessorInfo]="selectedLessorInfo"
      [isLoadingLessorAreaMaker]="isLoadingLessorAreaMaker"
      [lessorAreaMakers]="lessorAreaMakers"
      (emitLessorAreaMaker)="onEmitLessorAreaMaker($event)"
      (emitLessorAreaMakerDelete)="onEmitLessorAreaMakerDelete($event)"
      (emitTask)="onEmitBack($event)"
      ></cradua-survey-area>

    </ng-template>

    <ng-template  ngSwitchCase="lessorAcreage">
      <cradua-individual-acreages
      [selectedLessorInfo]="selectedLessorInfo"
      [terrains]="terrains"
      [measures]="measures"
      [isLoadingIndividualAcreages]="isLoadingIndividualAcreages"
      [individualAcreages]="individualAcreages"
      [selectedLandTitle]="selectedLandTitle"
      (emitIndividualAcreages)="onEmitIndividualAcreages($event)"
      (emitIndividualAcreagesDelete)="onEmitIndividualAcreagesDelete($event)"
      (emitTask)="onEmitBack($event)"
      ></cradua-individual-acreages>
      </ng-template>

      <ng-template  ngSwitchCase="lessorRepresentative">
        <cradua-lessor-representative
        [selectedLessorInfo]="selectedLessorInfo"
        [isLoadingLessorRepresentative]="isLoadingLessorRepresentative"
        [lessorRepresentatives]="lessorRepresentatives"
        [lessorRepTypes]="lessorRepTypes"
        [addressBook]="addressBooks"
        [banks]="banks"
        (emitLessorRepresentative)="onEmitLessorRepresentative($event)"
        (emitLessorRepresentativeDelete)="onEmitLessorRepresentativeDelete($event)"
        (emitTask)="onEmitBack($event)"
        ></cradua-lessor-representative>
        </ng-template>

      <ng-template  ngSwitchCase="stakeholder">
        <cradua-stakeholder
        [selectedLessorInfo]="selectedLessorInfo"
        [isLoadingLessorStakeholder]="isLoadingLessorStakeholder"
        [lessorStakeholders]="lessorStakeholders"
        [lessorRepTypes]="lessorRepTypes"
        [addressBook]="addressBooks"
        [banks]="banks"
        (emitLessorStakeholder)="onEmitLessorStakeholder($event)"
        (emitLessorStakeholderDelete)="onEmitLessorStakeholderDelete($event)"
        (emitTask)="onEmitBack($event)"
        ></cradua-stakeholder>
        </ng-template>
    </div>

</div>
